/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import Spinner from 'react-spinkit';
import PropTypes from 'prop-types';

import Money from '../../components/Money';

const PaymentFormWithoutCard = ({
  amount,
  panelLabel,
  confirmSetup,
  formDisabled,
  hasErrors,
}) => (
  <form
    className="c-card-information u-flex u-flex-column"
    onSubmit={confirmSetup}
  >
    <div className="c-payment-modal-heading u-mb">Payment Information</div>
    <div className="u-flex-1 u-flex u-flex-column u-justify-content-space-between">
      <div className="u-co-gray">
        By clicking charge you are authorizing us to charge the card that was provided when you booked the appointment.
      </div>
      <button className="c-button" disabled={formDisabled || hasErrors}>
        {
          formDisabled
            ? <Spinner name="three-bounce" className="c-checkout-modal__spinner" noFadeIn />
            : (
              <span>
                <span>{panelLabel}&nbsp;
                  { Number(amount) && <Money>{amount}</Money> }
                </span>
              </span>
            )
        }
      </button>
    </div>
  </form>
);

PaymentFormWithoutCard.propTypes = {
  formDisabled: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
  confirmSetup: PropTypes.func.isRequired,
  panelLabel: PropTypes.string,
  hasErrors: PropTypes.bool.isRequired,
};

PaymentFormWithoutCard.defaultProps = {
  panelLabel: 'Pay',
};

export default PaymentFormWithoutCard;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PaymentFormWithoutCard.jsx